if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();
        this.applyRenderAttributes(this.querySelector('model-viewer'));

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        const modelViewer = this.querySelector('model-viewer');
        if (!modelViewer) return;

        this.applyRenderAttributes(modelViewer);
        this.applyRenderProperties(modelViewer);
        this.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);
      }

      applyRenderAttributes(modelViewer) {
        if (!modelViewer) return;

        modelViewer.setAttribute('exposure', '0.6');
        modelViewer.setAttribute('environment-image', 'neutral');
        modelViewer.setAttribute('shadow-intensity', '0.5');
        modelViewer.setAttribute('tone-mapping', 'neutral');
      }

      applyRenderProperties(modelViewer) {
        modelViewer.exposure = 0.6;
        modelViewer.environmentImage = 'neutral';
        modelViewer.shadowIntensity = 0.5;
        modelViewer.toneMapping = 'neutral';
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
